import React from "react";
import GlobalSearch from "../../../components/Search";
import RightFilters from "./RightFilters";

function Filters() {
  return (
    <div className="tickets-filter d-flex justify-content-space-between bg-white">
      <GlobalSearch />
      <RightFilters />
    </div>
  );
}

export default Filters;
